import { combineReducers } from '@reduxjs/toolkit';

import site from "./site";

const rootReducer = combineReducers({
    site: site
});

export default rootReducer;